var _path, _g, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo80(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.6667 4H12.3333C7.17868 4 3 8.55856 3 14.1818V73.8182C3 79.4414 7.17868 84 12.3333 84H73.6667C78.8213 84 83 79.4414 83 73.8182V14.1818C83 8.55856 78.8213 4 73.6667 4Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1248_7906)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.5905 4H13.4092C8.43538 4 4.40332 8.39861 4.40332 13.8246V71.3684C4.40332 76.7944 8.43538 81.193 13.4092 81.193H72.5905C77.5643 81.193 81.5963 76.7944 81.5963 71.3684V13.8246C81.5963 8.39861 77.5643 4 72.5905 4Z",
    fill: "url(#paint0_linear_1248_7906)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8404 25.4242L40.9461 12.6496C41.5771 12.3628 42.3042 12.3462 42.9485 12.6039L73.0516 24.6424C75.3215 25.5502 74.9798 28.7492 72.5656 29.1915L59.1534 31.6485C58.6826 31.7348 58.1959 31.6873 57.7526 31.5119L42.9612 25.6589C42.3094 25.401 41.5746 25.4233 40.9409 25.7202L27.6595 31.9438C26.8074 32.3431 26.2665 33.1766 26.2665 34.0904V51.6603C26.2665 52.4891 26.7122 53.2585 27.444 53.6928L38.804 60.4355C40.4911 61.4369 42.0876 60.0637 42.0072 58.1546V44.8735C41.965 43.8707 42.5777 42.9496 43.5403 42.5687L57.4411 37.0681C58.0733 36.818 58.7847 36.8311 59.4065 37.1045L71.8295 42.5665C72.7115 42.9543 73.2775 43.8031 73.2775 44.7381V59.659C73.2775 60.5728 72.7366 61.4063 71.8845 61.8056L43.0018 75.3398C42.3284 75.6554 41.5431 75.6599 40.8658 75.3521L12.8404 62.6139C11.9739 62.22 11.4209 61.3791 11.4209 60.4551V27.583C11.4209 26.659 11.9739 25.8181 12.8404 25.4242Z",
    fill: "white",
    stroke: "url(#paint1_linear_1248_7906)",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2504 49.0206L43.9904 44.7031C43.9904 44.7031 43.7014 44.7031 43.7014 44.7991V58.6391C43.7014 58.6391 43.8253 58.759 43.9491 58.735L56.2092 55.9766C56.2092 55.9766 56.333 55.9287 56.333 55.8807V49.1166C56.333 49.1166 56.333 49.0446 56.2504 49.0206Z",
    fill: "url(#paint2_linear_1248_7906)",
    stroke: "url(#paint3_linear_1248_7906)",
    strokeWidth: 0.04
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2232 49.0206L71.4832 44.7031C71.4832 44.7031 71.7722 44.7031 71.7722 44.7991V58.6391C71.7722 58.6391 71.6484 58.759 71.5245 58.735L59.2645 55.9766C59.2645 55.9766 59.1406 55.9287 59.1406 55.8807V49.1166C59.1406 49.1166 59.1406 49.0446 59.2232 49.0206Z",
    fill: "url(#paint4_linear_1248_7906)",
    stroke: "url(#paint5_linear_1248_7906)",
    strokeWidth: 0.04
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1248_7906",
    x: 0.40332,
    y: 0,
    width: 85.1934,
    height: 85.1914,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_1248_7906"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1248_7906",
    x1: 30.4406,
    y1: 7.81907,
    x2: 45.292,
    y2: 80.7261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEB03C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB9A89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1248_7906",
    x1: 46.0606,
    y1: 12.1981,
    x2: 46.0606,
    y2: 75.8377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C17014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#997717"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1248_7906",
    x1: 43.2474,
    y1: 44.7031,
    x2: 47.3484,
    y2: 61.1712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2AD47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924782,
    stopColor: "#F99B83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAF064"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1248_7906",
    x1: 50.0172,
    y1: 44.7031,
    x2: 50.0172,
    y2: 58.7382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#997717"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1248_7906",
    x1: 72.2263,
    y1: 44.7031,
    x2: 68.1253,
    y2: 61.1712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2AD47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924782,
    stopColor: "#F99B83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAF064"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1248_7906",
    x1: 65.4564,
    y1: 44.7031,
    x2: 65.4564,
    y2: 58.7382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#997717"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo80);
export default __webpack_public_path__ + "static/media/logo_80.74d25a8b75ba2823b938d590a1857ab5.svg";
export { ForwardRef as ReactComponent };